import {Component} from '@wonderlandengine/api';

/**
 * etoy
 */
export abstract class EToy extends Component {
    static TypeName = 'etoy';

}
 